import { Component, Input, OnInit } from '@angular/core';
import { SectionTouched } from '../../shared/section-touched.class';
import { HandoverService } from 'src/app/services/handover.service';
import { NotificationService } from 'src/app/services/notification.service';
import { DialogService } from 'src/app/services/dialog.service';
import {
  ExecutiveSummary,
  ExecutiveSummaryAttachment,
} from 'src/app/interfaces/executive-summary';
import { HttpErrorResponse } from '@angular/common/http';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-handover-detail-executive-summary',
  templateUrl: './handover-detail-executive-summary.component.html',
  styleUrls: ['./handover-detail-executive-summary.component.scss'],
  standalone: false,
})
export class HandoverDetailExecutiveSummaryComponent
  extends SectionTouched
  implements OnInit
{
  @Input() handoverId: number | undefined;
  @Input() readOnlyContent!: boolean;

  isLoading = false;
  executiveSummaryAttachment: any;
  buttonFile = false;
  uploadfile = false;
  fileLimit = 1;
  executiveSummary: ExecutiveSummary = {} as ExecutiveSummary;
  originalExecutiveSummary: ExecutiveSummary = {} as ExecutiveSummary;
  dhoApiUrl = `${environment.urlBackend}/dhoapi`;

  constructor(
    private handoverService: HandoverService,
    private notificationService: NotificationService,
    public dialogService: DialogService
  ) {
    super();
  }

  ngOnInit(): void {
    if (this.handoverId) {
      this.isLoading = true;
      this.getExecutiveSummary();
      this.getExecutiveSummaryAttachments();
    }
  }

  onFileSelected(event: any): void {
    const file: File = event.target.files[0];
    if (this.handoverId && file) {
      this.isLoading = true;
      const formData = new FormData();
      formData.append('file', file);
      this.handoverService
        .saveExecutiveSummaryAttachment(this.handoverId, formData)
        .subscribe(
          (uploaded: ExecutiveSummaryAttachment[]) => {
            if (uploaded) {
              this.uploadfile = true;
              this.getExecutiveSummaryAttachments();
            }
          },
          (response: HttpErrorResponse) => {
            this.notificationService.notify(response.error.message, false);
          }
        );
      this.isLoading = false;
    }
  }

  getExecutiveSummaryAttachments(): void {
    if (this.handoverId) {
      this.isLoading = true;
      this.handoverService
        .getExecutiveSummaryAttachments(this.handoverId)
        .subscribe((file: ExecutiveSummaryAttachment[]) => {
          if (file) {
            this.executiveSummaryAttachment = file;
            this.buttonFile = true;
            this.uploadfile = true;
          }
          this.isLoading = false;
        });
    }
  }

  deleteExecutiveSummaryAttachment(file: any): void {
    const dialogRef = this.dialogService.openConfirmDialog(
      'Resumen Ejecutivo',
      `¿Está seguro de que desea eliminar el archivo?`
    );
    dialogRef.afterClosed().subscribe((res) => {
      if (res) {
        if (!this.handoverId) {
          return;
        }
        this.isLoading = true;
        this.handoverService
          .deleteExecutiveSummaryAttachment(this.handoverId, file)
          .subscribe((res: boolean) => {
            if (res) {
              delete this.executiveSummaryAttachment;
              this.getExecutiveSummaryAttachments();
            }
            this.isLoading = false;
          });
      }
    });
  }

  saveExecutiveSummary(): void {
    const dialogRef = this.dialogService.openConfirmDialog(
      'Resumen Ejecuivo',
      '¿Desea guardar el Resumen Ejecuivo?'
    );
    dialogRef.afterClosed().subscribe((res) => {
      if (res) {
        if (this.executiveSummary) {
          const executiveSummary = {
            handoverId: this.handoverId,
            executiveSummary: this.executiveSummary.executiveSummary,
          } as ExecutiveSummary;
          this.handoverService
            .saveExecutiveSummary(executiveSummary)
            .subscribe((comment: ExecutiveSummary) => {
              if (comment) {
                this.originalExecutiveSummary.executiveSummary =
                  this.executiveSummary.executiveSummary;
                this.reportPendingChanges();
                this.notificationService.notify(
                  'El Resumen Ejecuivo se ha guardado con éxito.',
                  true
                );
              } else {
                this.notificationService.notify(
                  'Ocurrió un error al grabar el Resumen Ejecuivo.',
                  false
                );
              }
            });
        }
      }
    });
  }

  getExecutiveSummary(): void {
    if (this.handoverId) {
      this.handoverService
        .getExecutiveSummary(this.handoverId)
        .subscribe((executiveSummary) => {
          if (executiveSummary) {
            this.originalExecutiveSummary.executiveSummary =
              executiveSummary.executiveSummary;
            this.originalExecutiveSummary.handoverId =
              executiveSummary.handoverId;
            this.executiveSummary.executiveSummary =
              executiveSummary.executiveSummary;
            this.executiveSummary.handoverId = executiveSummary.handoverId;
            this.isLoading = false;
          }
        });
    }
  }

  reportPendingChanges(): void {
    let thereAreChanges = false;
    thereAreChanges =
      this.originalExecutiveSummary.executiveSummary !=
      this.executiveSummary.executiveSummary;
    this.emitPendingChanges(thereAreChanges);
  }
}
